import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class DiagnosedProfileResultError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('DiagnosedProfileResultError', ...args);
    }
}
export default DiagnosedProfileResultError;
